// removed by extract-text-webpack-plugin
module.exports = {"loading":"styles__loading___dq7nh","bar":"styles__bar___bFfRG","progress":"styles__progress___149zI","messages":"styles__messages___1_15v","version":"styles__version___3lMPr"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/style-loader!./node_modules/css-loader?{"importLoaders":2,"minimize":true,"sourceMap":true,"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]","postcss":false}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js!./src/features/LoadingBar/styles.scss
// module id = 779
// module chunks = 0